import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-thermal-printer',
  templateUrl: './thermal-printer.component.html',
  styleUrls: ['./thermal-printer.component.css']
})
export class ThermalPrinterComponent implements OnInit {

  model = { 'table_name': 'thermal_printer', 'printer_id': '0', 'printer_name_en': '', 'printer_number': '', 'comment':'' };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<ThermalPrinterComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;
  }

  add() {
    if (this.model['printer_name_en'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['printer_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'printer_id': this.model['printer_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(" تمت العملية بنجاح ");
            this.dialog_data = {
              'status': data.status['type']
            };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
          }
        });
    }
    else if (this.model['printer_name_en'] == '') {
      alert("الرجاء إدخال اسم الطابعة");
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
